const time = (d: Date) =>
  d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })

/** "Today, 14:05" · "Yesterday, 09:30" · "12 Sep" */
export function formatWhen(ms: number, now = Date.now()): string {
  const d = new Date(ms)
  const today = new Date(now)
  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  ).getTime()
  if (ms >= startOfToday) return `Today, ${time(d)}`
  if (ms >= startOfToday - 86_400_000) return `Yesterday, ${time(d)}`
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}
